interface EpisodeSelectorProps {
  episodes: number;
  current: number;
  onChange: (episode: number) => void;
}

export default function EpisodeSelector({ episodes, current, onChange }: EpisodeSelectorProps) {
  if (episodes <= 1) return null;

  return (
    <section className="mt-8">
      <div className="mb-3 flex items-center gap-2">
        <i className="ri-list-check-2 text-accent-500" />
        <h2 className="font-heading text-lg font-600 text-foreground-950">选集</h2>
        <span className="text-xs text-foreground-500">共 {episodes} 集</span>
      </div>

      <div className="max-h-56 overflow-y-auto rounded-lg border border-background-200/70 bg-background-100/50 p-3">
        <div className="grid grid-cols-4 gap-2 sm:grid-cols-6 md:grid-cols-8 lg:grid-cols-10">
          {Array.from({ length: episodes }, (_, i) => i + 1).map((ep) => (
            <button
              key={ep}
              type="button"
              onClick={() => onChange(ep)}
              className={`whitespace-nowrap rounded-md py-2 text-sm transition-colors ${
                ep === current
                  ? "bg-accent-500 font-600 text-background-50"
                  : "bg-background-200/70 text-foreground-600 hover:bg-background-300 hover:text-foreground-950"
              }`}
            >
              {ep}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-3 flex items-center gap-2 rounded-md border border-primary-500/30 bg-primary-500/10 px-4 py-3 text-sm text-foreground-600">
        <i className="ri-information-line text-accent-500" />
        当前选集：第 {current} 集（演示状态，本站暂不支持真实播放）
      </div>
    </section>
  );
}